<template>
  <v-card elevation="0" dense class="auto-mx">
    <v-card-text>
      <v-row no-gutters justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-select
            dense
            v-model="selected"
            item-text="name"
            :items="$store.state.messangerItems"
            label="Context"
            hide-details
            :menu-props="{ bottom: true, offsetY: true }"
            solo
            @change="onChange"
            return-object
          >
            <template v-slot:selection="{ item }">
              <v-list-item dense>
                <v-list-item-action>
                  <CleedIcon :icon="item.icon" :dark="true" />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ $t(`drawer.contexts.${item.mode}`) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:item="{ item }">
              <CleedIcon :icon="item.icon" :dark="true" class="ma-3" />
              <span>
                {{ $t(`drawer.contexts.${item.mode}`) }}
              </span>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import CleedIcon from "@/components/core/CleedIcon.vue";
export default {
  name: "conversationFiltes",
  data() {
    return {
      selected: "",
    };
  },
  components: {
    CleedIcon,
  },
  computed: {
    contexts() {
      const data = this.$store.state.messangerItems.map((e, index) => {
        e.index = index;
        return e;
      });
      return data;
    },
    messanger_type_index() {
      return this.$store.state.messanger_type_selected;
    },
  },
  created() {
    this.selected = this.contexts[this.messanger_type_index].name;
    this.$emit("selectNewContext", this.contexts[this.messanger_type_index]);
    console.log("created", this.selected);
  },
  methods: {
    onChange(e) {
      this.$emit("selectNewContext", e);
    },
  },
};
</script>
